import { useParams } from 'react-router';
import { useGetPatientNonMedicalDocuments } from '../../../../hooks/patientsAPI';
import { NonMedicalDocumentsTable } from './NonMedicalDocumentsTable';
import type { DocumentViewerData } from '../../PatientProfile';

interface NonMedicalDocumentsSectionProps {
  onViewDocument: (document: DocumentViewerData) => void;
}

export const NonMedicalDocumentsSection = ({
  onViewDocument,
}: NonMedicalDocumentsSectionProps) => {
  const { patientId } = useParams<{ patientId: string }>();

  const { data, isFetching } = useGetPatientNonMedicalDocuments(patientId);

  return (
    <NonMedicalDocumentsTable
      documents={data?.documents ?? []}
      isLoading={isFetching}
      onViewDocument={onViewDocument}
    />
  );
};
